import { Component, OnInit } from '@angular/core';
import { FindingService } from '../../service/finding/finding.service';
import { Finding } from '../../class/finding';
import { Message, ConfirmationService, LazyLoadEvent, CalendarModule, ToggleButtonModule } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';


@Component({
  selector: 'app-findings',
  templateUrl: './findings.component.html',
  styleUrls: ['./findings.component.scss']
})
export class FindingsComponent implements OnInit {

    public promiseForm: Promise<any>;

    public msgs: Message[] = [];
    public findings: Finding[];
    public selectFinding: Finding;
    public findingID: Number = 0;
    public modNew = false;
    public modView = false;
    public openFinding = false;
    public totalRecords: number;
    public page: number;
    public per_page: number;
    public sort: string;

    constructor(
        public findingService: FindingService,
        public confirmationService: ConfirmationService,
        public hasPermissionService: HasPermissionService,
        public translate: TranslateService) { }

    ngOnInit() {
        this.page = 1;
        this.per_page = 10;

        //this.getFindings();
    }

    public loadFindingsLazy(event: LazyLoadEvent) {
        this.page = (event.first / this.per_page) + 1;
        if (event.sortOrder === -1) {
            this.sort =  '-' + event.sortField;
        } else {
            this.sort =  event.sortField;
        }
        this.getFindings(event.globalFilter);
    }

    public getFindings(query?: string) {
        this.findingService.getFinding(this.page, this.per_page, this.sort, query).toPromise().then(
            response => {
                this.findings = response.json().data;
                if (response.json().meta.total > response.json().meta.total_filtered) {
                    this.totalRecords = response.json().meta.total_filtered;
                } else {
                    this.totalRecords = response.json().meta.total;
                }
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public newFinding() {
        this.modNew = !this.modNew;
        this.selectFinding = null;
    }

    public savedFinding(res) {
        this.msgs = [];
        this.msgs.push(res);
        this.selectFinding = null;
        this.modNew = false;
        this.getFindings();
    }

    public cancelFinding (res) {
        this.selectFinding = null;
        this.modNew = false;
        this.modView = false;
        this.getFindings();
    }

    public edit(finding: Finding) {
        this.modNew = true;
        this.selectFinding = finding;
        this.getFindings();
    }

    public view(finding: Finding) {
        this.openFinding = true;
        this.selectFinding = finding;
        this.findingID = finding.id;
        this.modView = true;
    }

    public deleteDialog(finding: Finding) {
        let message;
        this.translate.get('Do you want to delete?').subscribe((res: string) => {
            message = res;
        });

        let header;
        this.translate.get('Delete Confirmation').subscribe((res: string) => {
            header = res;
        });

        this.confirmationService.confirm({
            message: message,
            header: header,
            icon: 'fa fa-trash',
            accept: () => {
                this.delete(finding);
            }
        });
    }

    public delete(finding: Finding) {
        this.findingService.deleteFinding(finding.id).toPromise().then(
            response => {
                this.msgs = [];
                this.msgs.push( { severity: 'success', summary: 'deleted' } );
                this.getFindings();
            },
            error => {
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public activeFinding(finding: Finding) {
        this.putFinding(finding);
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }

    public putFinding(values: Finding) {
        const param = {
            'activated': values.activated
        };
        if (values) {
            const promise = this.findingService.updateFinding(values.id, param);
            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.msgs = [];
                        this.msgs.push( { severity: 'success', summary: res  } );
                    });
                },
                error => {
                    this.msgs.push( { severity: 'error', summary: 'Error' } );
                }
            );
        }
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/findings/findings.component.ts